<template>
  <div v-if="flight.disclaimers?.length > 0 || (props.wantsChaperoned && !flight.is_group_flight)" class="warnings">
    <div v-if="flight.disclaimers?.length > 0">
      <div class="list">
        <div v-for="w in flight.disclaimers" :key="w.title" class="warning">
          <div class="problem">{{ w.title }}</div>
          <p>{{ w.description }}</p>
        </div>
      </div>
    </div>
    <div v-if="!props.isSummary" class="accept" :class="{ lookatme: isDisclaimerError }">
      <div v-if="flight.disclaimers?.length > 0" class="checkboxlabel" :class="{ on: disclaimerAccepted === true }" @click="emit('update:disclaimerAccepted', !disclaimerAccepted)">
        <div class="checkbox" />
        <label>I acknowledge and accept the risks described above</label>
      </div>
      <div v-if="props.wantsChaperoned && !flight.is_group_flight" class="checkboxlabel" :class="{ on: unchaperonedAccepted === true }" @click="emit('update:unchaperonedAccepted', !unchaperonedAccepted)">
        <div class="checkbox" />
        <label>I acknowledge and accept this is not a {{ groupFlightLabel }} flight</label>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject, ref } from "vue";

const emit = defineEmits(["update:disclaimerAccepted", "update:unchaperonedAccepted"]);
const props = defineProps(["flight", "isLander", "isSummary", "wantsChaperoned", "isDisclaimerError", "disclaimerAccepted", "unchaperonedAccepted"]);

const groupFlightLabel = inject("groupFlightLabel", ref("Chaperoned"));
</script>

<style lang="less">
#flights {
  .warnings {
    padding: 1rem 0;
  }

  .warning {
    margin-top: 1rem;

    .problem {
      color: @secondary;
      margin-bottom: 0.5rem;
    }

    p {
      color: @mid;
    }

    &:first-child {
      margin-top: 0;
    }
  }

  .accept {
    padding-top: 1rem;

    .checkboxlabel {
      margin-bottom: 1rem;
    }
  }

  .lookatme {
    color: @secondary;
    animation: shake 0.5s;
  }
}

@keyframes shake {
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-8px);
  }
  50% {
    transform: translateX(8px);
  }
  75% {
    transform: translateX(-8px);
  }
  100% {
    transform: translateX(0);
  }
}
</style>
